<h2 mat-dialog-title>Configurar parameters_objects</h2>

<mat-dialog-content [formGroup]="form_group" class="parameter-objects-modal">
  <div class="parameter-objects-modal__hero">
    <div>
      <p class="parameter-objects-modal__eyebrow">{{ data.dashboard_name || 'Dashboard' }}</p>
      <h3>Parametros configurados</h3>
    </div>

    <div class="parameter-objects-modal__actions">
      <button mat-stroked-button type="button" color="primary" (click)="add_item()">
        <mat-icon>add</mat-icon>
        Agregar
      </button>
    </div>
  </div>

  <div *ngIf="!has_items" class="parameter-objects-modal__empty">
    Aun no existen parameters_objects para este dashboard.
  </div>

  <div formArrayName="items" class="parameter-objects-modal__list">
    <div *ngFor="let item of items_array.controls; let i = index" [formGroupName]="i" class="parameter-objects-modal__row">
      <div class="parameter-objects-modal__row-head">
        <div class="parameter-objects-modal__preview">
          <span class="parameter-objects-modal__preview-label">Clave</span>
          <strong>{{ preview_key(i) }}</strong>
        </div>
        <button mat-icon-button color="warn" type="button" (click)="remove_item(i)" aria-label="Eliminar parametro">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <div class="parameter-objects-modal__grid">
        @for (field of field_config; track field.control_name) {
          <mat-form-field appearance="outline">
            <mat-label>{{ field.label }}</mat-label>

            @if (is_text_field(field.control_name)) {
              <input
                matInput
                [formControlName]="field.control_name"
                [placeholder]="field.placeholder || ''" />
            }

            @if (is_select_field(field.control_name)) {
              <mat-select [formControlName]="field.control_name">
                @for (option of get_options(field.control_name); track option.value) {
                  <mat-option [value]="option.value">
                    {{ option.view_value }}
                  </mat-option>
                }
              </mat-select>
            }

            @if (get_control_error(item.get(field.control_name), 'required')) {
              <mat-error>El campo es obligatorio.</mat-error>
            }

            @if (get_control_error(item.get(field.control_name), 'minlength')) {
              <mat-error>Ingresa al menos 2 caracteres.</mat-error>
            }
          </mat-form-field>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="parameter-objects-modal__footer">
  <button mat-button type="button" (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">Guardar</button>
</mat-dialog-actions>
